/* ============================================================
   Gold Coast Naturals — Shopify theme JS
   Ports the original site behaviour (theme toggle, sticky header,
   mobile nav, scroll reveal, year) and adds Shopify AJAX cart.
   ============================================================ */

// ---------- Theme toggle (light / dark) ----------
(function () {
  const t = document.querySelector('[data-theme-toggle]');
  const r = document.documentElement;
  if (!t) return;
  const stored = localStorage.getItem('gcn-theme');
  let d = stored || (matchMedia('(prefers-color-scheme:dark)').matches ? 'dark' : 'light');
  r.setAttribute('data-theme', d);
  const sun = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>';
  const moon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
  const render = () => {
    t.setAttribute('aria-label', 'Switch to ' + (d === 'dark' ? 'light' : 'dark') + ' mode');
    t.innerHTML = d === 'dark' ? sun : moon;
  };
  render();
  t.addEventListener('click', () => {
    d = d === 'dark' ? 'light' : 'dark';
    r.setAttribute('data-theme', d);
    localStorage.setItem('gcn-theme', d);
    render();
  });
})();

// ---------- Sticky header shadow ----------
(function () {
  const header = document.getElementById('header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('header--scrolled', window.scrollY > 12);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

// ---------- Mobile nav ----------
(function () {
  const btn = document.getElementById('navToggle');
  const nav = document.getElementById('mobileNav');
  if (!btn || !nav) return;
  btn.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    btn.setAttribute('aria-expanded', open);
  });
  nav.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => {
    nav.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
  }));
})();

// ---------- Scroll reveal ----------
(function () {
  const els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('in')); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  els.forEach((e) => io.observe(e));
})();

// ---------- Year ----------
(function () { const y = document.getElementById('year'); if (y) y.textContent = new Date().getFullYear(); })();

// ============================================================
//  Shopify AJAX cart
// ============================================================
(function () {
  const moneyFormat = window.GCN && window.GCN.moneyFormat ? window.GCN.moneyFormat : '${{amount}}';

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(
      moneyFormat.indexOf('amount_no_decimals') > -1 ? 0 : 2
    );
    return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, value);
  }

  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  const cartItemsEl = document.getElementById('cartItems');
  const cartSubtotalEl = document.getElementById('cartSubtotal');
  const cartCountEls = document.querySelectorAll('[data-cart-count]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function updateCartCount(count) {
    cartCountEls.forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    if (cartSubtotalEl) cartSubtotalEl.textContent = formatMoney(cart.total_price);
    if (!cartItemsEl) return;
    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
      return;
    }
    cartItemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-line" data-key="${item.key}">
        <div class="cart-line__img">${item.image ? `<img src="${item.image.replace(/(\.[^.]*)$/, '_120x$1')}" alt="${item.product_title}">` : ''}</div>
        <div class="cart-line__body">
          <h3>${item.product_title}</h3>
          <p>${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '4 oz · small batch'}</p>
          <div class="qty">
            <button class="qty__btn" data-qty-down aria-label="Decrease quantity">&minus;</button>
            <span class="qty__val">${item.quantity}</span>
            <button class="qty__btn" data-qty-up aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div class="cart-line__price">${formatMoney(item.final_line_price)}</div>
      </div>`).join('');
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then((r) => r.json());
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then((r) => r.json());
  }

  // Add-to-cart forms (product section + lineup live card)
  document.querySelectorAll('form[data-cart-form]').forEach((form) => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
      const data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      })
        .then((r) => r.json())
        .then(() => {
          if (form.hasAttribute('data-checkout-direct')) {
            window.location.href = '/checkout';
            return null;
          }
          return fetchCart();
        })
        .then((cart) => {
          if (!cart) return;
          renderCart(cart);
          openDrawer();
        })
        .catch(() => { window.location.href = '/checkout'; })
        .finally(() => { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
    });
  });

  // Quantity controls inside drawer (event delegation)
  if (cartItemsEl) {
    cartItemsEl.addEventListener('click', function (e) {
      const up = e.target.closest('[data-qty-up]');
      const down = e.target.closest('[data-qty-down]');
      if (!up && !down) return;
      const line = e.target.closest('.cart-line');
      if (!line) return;
      const key = line.getAttribute('data-key');
      const current = parseInt(line.querySelector('.qty__val').textContent, 10);
      const next = up ? current + 1 : current - 1;
      changeLine(key, next).then((cart) => renderCart(cart));
    });
  }

  // Open / close drawer triggers
  document.querySelectorAll('[data-cart-open]').forEach((el) => {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart().then((cart) => { renderCart(cart); openDrawer(); });
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', closeDrawer));
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Initial count on load
  fetchCart().then((cart) => updateCartCount(cart.item_count)).catch(() => {});
})();
